module.exports = "/assets/data/7fdaca2a8533c5b1d0aefea1e2fdbb45-B37.data.json";